/** Agency-facing brand constants used across the editor. */
export const AGENCY_NAME = "Review Presence";
export const APP_TITLE = "Website Editor";
export const AGENCY_SITE_URL = "https://reviewpresence.com";
export const CONTACT_URL = "https://reviewpresence.com/contact";
